"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useForwardedRef = void 0;
const react_1 = require("react");
function useForwardedRef(ref) {
    const innerRef = (0, react_1.useRef)(null);
    const refs = Array.isArray(ref) ? ref : [ref];
    (0, react_1.useEffect)(() => {
        refs.forEach(el => {
            if (!el)
                return;
            if (typeof el === 'function') {
                el(innerRef.current);
            }
            else {
                // eslint-disable-next-line no-param-reassign
                el.current = innerRef.current;
            }
        });
    });
    return innerRef;
}
exports.useForwardedRef = useForwardedRef;
//# sourceMappingURL=forwarded-ref.js.map